module.exports = __webpack_public_path__ + "static/img/team.c4854767.webp";